import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { Employee, FilterParams, GovernanceRequestApi, LookupApi, LookupField, RoleType, UserApi } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { DialogService } from 'src/app/core/dialog.service';
import { FilterBase } from 'src/app/immigration/services/filters/filter-base';
import { isNullOrUndefined } from '../../../app/core/utils';
import { BusinessTravel } from 'src/app/immigration/services/visatypes/country-types.enum';

@Component({
  selector: 'eos-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {

  @Input() filters: FilterBase[];
  @Input() exitType: string="";
  @Input() form: UntypedFormGroup;
  @Input() immigrationCountry: string;
  @Input() locationWiseAccess: boolean;
  selectedValues;
  selectedCounter;
  country: string;
  employeesInOfficeLe: Employee[] = [];
  constructor(
    private userApi: UserApi,
    private lookUpApi: LookupApi,
    private common: CommonService,
    private activeRoute: ActivatedRoute,
    private dialog: DialogService,
    private datePipe: DatePipe
  ) {
    this.activeRoute.params.subscribe(routeParams => {
      this.country = routeParams.country;
    });

  }

  ngOnInit() {
    this.filters.forEach(filter => this.loadOptions(filter));  
  }

  fetchEmployees(leIds: number[]) {
    const fl = new FilterParams();
    fl.legalEntityId = leIds;
    return this.userApi.getAllEmployeesByRoleAndOfficeLegalEntity(9, this.country, fl).pipe(map(emp => {
      emp.forEach(e => {
        e.disabled = false;
        e.isActive = true;
        return e;
      });
      return emp;
    }));
  }

   fetchEmployeesBasedonRole() {   
    return this.userApi.getEmployeesInRoles([RoleType.VisaApprover]).pipe(map(emp => {
      emp.forEach(e => {
        e.disabled = false;
        e.isActive = true;
        return e;
      });
      return emp;
    }));    
  }

  fetchEmployeesByOfficeLocation(officeIds: number[]) {
    const fl = new FilterParams();
    fl.officeLocationId = officeIds;
    return this.userApi.getAllEmployeesByRoleAndOfficeLocation(9, this.country, fl).pipe(map(emp => {
      emp.forEach(e => {
        e.disabled = false;
        e.isActive = true;
        return e;
      });
      return emp;
    }));
  }

  updateVisaApprovers(officeLes: LookupField[]) {
    if (officeLes !== null && officeLes.length) {
      this.fetchEmployees(officeLes.map(le => le.id)).subscribe(resp => {
        this.employeesInOfficeLe = resp;
        if (!isNullOrUndefined(this.form.value.consultantId) && this.form.value.consultantId.length > 0) {
          this.form.patchValue({
            consultantId: this.employeesInOfficeLe.filter(emp => this.form.value.consultantId.includes(emp.id)).map(emp => emp.id)
          });
        }
      });
    }
  }

  updateVisaApproversAccordingToOfficeLocation(officeLocations: LookupField[]) {
    if (officeLocations !== null && officeLocations.length) {
      this.fetchEmployeesByOfficeLocation(officeLocations.map(le => le.id)).subscribe(resp => {
        this.employeesInOfficeLe = resp;
        if (!isNullOrUndefined(this.form.value.consultantId) && this.form.value.consultantId.length > 0) {
          this.form.patchValue({
            consultantId: this.employeesInOfficeLe.filter(emp => this.form.value.consultantId.includes(emp.id)).map(emp => emp.id)
          });
        }
      });
    } else {
      this.employeesInOfficeLe = null;
    }
  }


  loadOptions(filter: FilterBase) {
    switch (filter.controlType) {
      case 'empdropdown':        
        if(this.country == BusinessTravel.Value)
        {
          this.fetchEmployeesBasedonRole().subscribe(resp => {
            this.employeesInOfficeLe = resp;
          });
        }
        else if (!isNullOrUndefined(this.form.value.legalEntityId) && this.form.value.legalEntityId.length > 0) {
          this.fetchEmployees(this.form.value.legalEntityId).subscribe(resp => {
            this.employeesInOfficeLe = resp;
          });
        }
        break;
      case 'LocationBasedEmpDropDown':

       let officeId = !isNullOrUndefined(this.form.value.officeToBeVisitedId) ? this.form.value.officeToBeVisitedId : this.form.value.locationId;
        if (!isNullOrUndefined(officeId) && officeId.length > 0) {
          this.fetchEmployeesByOfficeLocation(officeId).subscribe(resp => {
            this.employeesInOfficeLe = resp;
          });
        }
        break;
      case 'lookupdropdown':
        this.lookUpApi.getLookupTypeById(filter.optionsType, filter.parentFieldId).subscribe(resp => {
          if (this.exitType === 'VoluntaryExit' || this.exitType === 'InvoluntaryExit') {
            filter.options = resp.lookupFields.filter(i => (![13425].includes(i.id))); //Exclude 'Extended'
          } 
          else if (this.exitType === 'InternExit' ){
            filter.options = resp.lookupFields.filter(i => (![10858].includes(i.id))); //Exclude 'OnHold'
          }
          else {
            filter.options = resp.lookupFields;
          }
        });
        break;

      case 'globalRank':
        this.lookUpApi.getGlobalRanks().subscribe(resp => {
          filter.options = resp;
        });
        break;

      case 'radio':
        this.lookUpApi.getLookupTypeById(filter.optionsType, filter.parentFieldId).subscribe(resp => {
          filter.options = resp.lookupFields;
        });
        break;

      case 'CountryOfficeLocationWithConsultantChange':
        if (this.common.isVisaApprover && this.locationWiseAccess) {
          this.lookUpApi.getOfficeLocationByCountryCodeAndEmployee(this.country).subscribe(resp => {
            filter.options = resp;
          });
        } else {
          this.lookUpApi.getLookupTypeById(filter.optionsType, filter.parentFieldId).subscribe(resp => {
            filter.options = resp.lookupFields;
          });
        }
        break;

      case 'serviceLine':
        this.lookUpApi.getServiceLines(filter.optionsType, undefined).subscribe(resp => {
          filter.options = resp;
        });
        break;

      case 'subServiceLine':
        this.lookUpApi.getSubServiceLines(filter.optionsType, undefined).subscribe(resp => {
          filter.options = resp;
        });
        break;
      case 'officeLe':
         if (this.common.isVisaApprover && this.country != BusinessTravel.Value) {
          this.lookUpApi.getOfficeLEByCountryCodeAndEmployeeId(this.country).subscribe(resp => {
            filter.options = resp;
          });
        } else {
          this.lookUpApi.getOfficeLEByCountryCode(this.country).subscribe(resp => {
            filter.options = resp;
          });
        }
        break;

      case 'OfficeLeWithoutConnectedFilters':
        this.lookUpApi.getOfficeLEByCountryCode(this.country).subscribe(resp => {
          filter.options = resp;
        });
        break;

      case 'exitEmpDropdown':
        this.common.prepareEmployeeByRoleForGridFilterObservable(filter.optionsType).subscribe(resp => {
          filter.options = resp;
        });;
        break;
    
      case 'exitTypeDropdown':
        this.lookUpApi.getLookupTypeById(filter.optionsType, filter.parentFieldId)
        .pipe(map(item =>item.lookupFields.filter(i => [10859,10860,13395].includes(i.id)))) 
        .subscribe(resp => {
          filter.options = resp
        });;
        break;

      case 'locationdropdownBasedonEmployee':
        this.lookUpApi.getOfficeLocationByEmployee(filter.optionsType, filter.parentFieldId).subscribe(resp => {
          filter.options = resp.lookupFields;
        });
        break;

      case 'governanceEmployeeLocation':
        this.common.prepareEmployeeOfficeLocationsObv().subscribe(resp => {
          filter.options = resp;
        });
        break;

      case 'governanceCountry':
        // Load all countries, but only show those the employee has locations in
        this.common.prepareEmployeeOfficeLocationsObv().subscribe(locations => {
          const countryIds = [...new Set(locations.map((loc: any) => loc.parentFieldId))].filter(id => id != null);
          this.lookUpApi.getLookupTypeById(filter.optionsType, undefined).subscribe(resp => {
            filter.options = resp.lookupFields.filter((c: any) => countryIds.includes(c.id));
          });
        });
        break;

      case 'governanceEmployeeLegalEntity':
        this.common.prepareEmployeeOfficeLegalEntitesObv().subscribe(resp => {
          filter.options = resp;
        });
        break;
             case 'governanceDocumentType':
        this.common.prepareGovDocumentType().subscribe((resp: any) => {
          filter.options = (resp || []).filter(d=>d.isActive).map(d => ({ id: d.id, displayText: d.documentTypeName }));
        });
        break;
              case 'governanceProcessOwnerDropdown':
        this.common.prepareGovProcessOwners().subscribe((resp: any[]) => {
          filter.options = (resp || []).map(po => ({ id: po.id, displayText: po.name }));
        });
        break;
    }

   
  }

  // adjustValues() {
  //   const res = this.form.getRawValue();
  //   const value = res['selectedValues'].map((obj: any) => obj.id);
  //   const cont = this.form.controls[this.filter.key];
  //   if (res['selectedValues'].length > 0) {
  //     cont.patchValue(value);
  //   } else {
  //     cont.patchValue('');
  //   }
  // }


  openMod() {
    const f = new FilterParams();
    f.startDate = this.form.value.submissionstartDate;
    f.endDate = this.form.value.submissionendDate;

    this.dialog.showDateRangeFilter(f, (submissionstartDate: Date, submissionendDate: Date) => {
      this.form.patchValue({
        submissionstartDate,
        submissionendDate
      });

    }, "Select submission date range");
  }

  openExitDateMod() {
    const f = new FilterParams();
    f.startDate = this.form.value.exitDateLowerBound;
    f.endDate = this.form.value.exitDateUpperBound;

    this.dialog.showDateRangeFilter(f, (exitDateLowerBound: Date, exitDateUpperBound: Date) => {
      this.form.patchValue({
        exitDateLowerBound,
        exitDateUpperBound
      });

    }, "Select exit date range");
  }

  clearDate() {
    this.form.patchValue({
      submissionstartDate: null,
      submissionendDate: null
    });
  }
  clearexitDate() {
    this.form.patchValue({
      exitDateLowerBound: null,
      exitDateUpperBound: null
    });
  }

    openExpiryDateMod() {
    const f = new FilterParams();
    f.startDate = this.form.value.expiryStartDate;
    f.endDate = this.form.value.expiryEndDate;

    this.dialog.showDateRangeFilter(f, (expiryStartDate: Date, expiryEndDate: Date) => {
      this.form.patchValue({
        expiryStartDate,
        expiryEndDate
      });
    }, "Select expiry date range");
  }

  clearExpiryDate() {
    this.form.patchValue({
      expiryStartDate: null,
      expiryEndDate: null
    });
  }

  // Allows a selected radio filter to be unselected by clicking it again.
  // Native radio inputs cannot be deselected, so when the clicked option is
  // already the current value we reset the control back to null. The reset is
  // deferred so it runs after the browser's default click re-checks the radio.
  onRadioClick(filter: FilterBase, optionId: any) {
    if (this.form.get(filter.key)?.value === optionId) {
      setTimeout(() => this.form.get(filter.key)?.setValue(null));
    }
  }
}
